import moment from 'moment';

const formatWeddingDate = date => (moment.utc(date).isValid()
  ? moment.utc(date).format('MMMM, D, YYYY')
  : null
);

const formatLocation = (city, state) => {
  if (city && state) return `${city}, ${state}`;
  if (city) return city;
  if (state) return state;
  return null;
};

export { formatWeddingDate, formatLocation };



// WEBPACK FOOTER //
// ./src/components/manage/website/util/previewUtils.js